// Constants for state values
const CONSTANTS = {
  // Button states
  STATES: {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    INITIAL: 'initial',
  },

  // DOM Selectors
  SELECTORS: {
    // Common
    SECTION: '[data-section-state]',
    BUTTON: '[data-button-state]',
    LAZY_IMAGE: '.lazy',
    OPTION_DETAILS: '.option-btn-sub-text',
    TITLE_EL: '.ProductTitle--text',

    // Product sections
    SIBLING_PRODUCTS: 'sibling-products',
    SIBLING_VARIANTS: 'sibling-variants',
    SIBLING_ADD_ONS: 'sibling-add-ons',
    BASE_CART_SUMMARY: 'base-cart-summary',

    // Form elements
    FORM: '.add-to-cart-form',
    FORM_WRAPPER: 'product-form',
    MAIN_VARIANT_INPUT: 'input[name="id"]',
    SUBSCRIPTION_INPUT: 'input[data-selling-plan-id]',
    ADD_ON_INPUT: '.pdp_addons',

    // Cart summary elements
    ADD_TO_CART_BUTTON: 'product-form button',
    ADD_TO_CART_BUTTON_TEXT: '.add-to-cart-button-text',
    NOTIFY_ME_BUTTON: '[data-notify-btn]',
    CART_TOTAL_PRICE: '.CartTotal .CartTotal-value',
    CART_TOTAL_COMPARE_PRICE: '.CartTotal .CartTotal-value--compare-at-price',

    // Delivery info
    DELIVERY_MESSAGE: '[data-pdp-delivery-message]',
    DELIVERY_ACCENT: '[data-pdp-delivery-accent]',
    DELIVERY_FREE_SHIPPING_TEXT: '[data-pdp-delivery-accent] .shipping-info-accent',
    BIS_PRODUCT_ID: 'bis_product_id',
    BIS_VARIANT_ID: 'bis_variant_id',
    DELIVERY_MESSAGE_PROPERTIES_ID: 'properties-delivery_message',

    // Product features
    PRODUCT_FEATURES: '.js-product-features-section',

    // Swiper/carousel elements
    SWIPER_CONTAINER: '.swiper-product-images-container',
    SWIPER_PAGINATION: '.swiper-pagination',
    SWIPER_BUTTON_NEXT: '.swiper-button-next',
    SWIPER_BUTTON_PREV: '.swiper-button-prev',
    PRODUCT_CAROUSEL: '.product-carousel-container',

    // UI elements
    MOBILE_PRODUCT_TITLE: '.ProductHeader-wrapper--mobile',
    SECTION_HEADER: '.section-header',

    // Specs modal selectors
    SPECS_MODAL: '[data-product-specs-modal]',
    // common specs selectors
    SPEC_FIELD: 'product-spec__copy-inner',
    SPEC_TITLE: 'spec__row-title',
    SPEC_VALUE: 'spec__row-value',
    // Product-related fields
    SPEC_PRODUCT_CAPACITY: '[spec-product-capacity]',
    SPEC_PRODUCT_LINERCODE: '[spec-product-linercode]',
    SPEC_PRODUCT_POWER_SOURCE: '[spec-product-power-source]',
    SPEC_PRODUCT_INGREDIENTS: '[spec-product-ingredients]',
    SPEC_PRODUCT_MAGNIFICATION: '[spec-product-magnification]',
    SPEC_PRODUCT_COMPATIBILITY: '[spec-product-compatibility]',
    SPEC_PRODUCT_BATTERY_LIFE: '[spec-product-battery-life]',
    DIMENSION_IMAGE: '[data-product-dimension-image]',
    // Variant-related fields
    // SPEC_VARIANT_MATERIAL: '[spec-variant-material]',
    SPEC_VARIANT_WARRANTY: '[spec-variant-warranty]',
    SPEC_VARIANT_SKU: '[spec-variant-sku]',
    SPEC_VARIANT_COATING: '[spec-variant-coating]',

    // Dropdown and subscription elements
    DROPDOWN: '[data-subscription-dropdown]',
    DROPDOWN_BUTTON: '[data-dropdown-button]',
    SUBSCRIPTION_PICKER: '[data-sibling-subscription-id]',
    SUBSCRIPTION_OPTION: '[data-subscription-option-id]',

    // Variant elements
    VARIANT_IMAGES: '[data-swiper-variant-id]',
    SELECTED_SWATCH: '[data-selected-swatch]',
    SELECTED_VARIANT_DATA: '[data-selected-variant]',

    // Additional
    ADD_ON_WRAPPER: '.addon-picker-wrapper',
  },

  // Data attributes
  DATA_ATTR: {
    // Button and section states
    BUTTON_STATE: 'data-button-state',
    SECTION_STATE: 'data-section-state',

    // Sibling product/variant references
    SIBLING_PRODUCT_ID: 'data-sibling-product-id',
    SIBLING_VARIANT_ID: 'data-sibling-variant-id',
    SIBLING_VARIANT_REF: 'data-sibling-variant-ref',

    // Default/initial values
    DEFAULT_PRODUCT_ID: 'data-default-product-id',
    DEFAULT_VARIANT_ID: 'data-default-variant-id',
    PRODUCT_TYPE: 'data-product-type',
    SINGLE_VARIANT_SIBLINGS: 'data-single-variant-siblings',

    // Add-on related
    MAX_ADD_ONS: 'data-max-add-ons',
    ADD_ON_INDEX: 'data-add-on-index',
    ADD_ON_VARIANT_ID: 'data-add-on-variant-id',
    ADD_ON_PRODUCT_ID: 'data-add-on-product-id',
    ADD_ON_TITLE: 'data-add-on-title',
    ADD_ON_PRICE: 'data-add-on-price',
    ADD_ON_COMPARE_AT_PRICE: 'data-add-on-compare-at-price',
    ADD_ON_MATCH_SWATCH: 'data-add-on-match-swatch',

    // Subscription related
    DROPDOWN: 'data-subscription-dropdown',
    DROPDOWN_BUTTON: 'data-dropdown-button',
    SIBLING_SUBSCRIPTION_ID: 'data-sibling-subscription-id',
    SIBLING_SUBSCRIPTION_PRICE: 'data-sibling-subscription-price',
    SIBLING_SUBSCRIPTION_SUMMARY: 'data-sibling-subscription-summary',
    SUBSCRIPTION_OPTION_ID: 'data-subscription-option-id',
    SUBSCRIPTION_OPTION_PRICE: 'data-subscription-option-price',
    SUBSCRIPTION_OPTION_SUMMARY: 'data-subscription-option-summary',

    // Image related
    PREVIEW_IMAGE_PRODUCT_ID: 'data-preview-image-product-id',
    SWIPER_PRODUCT_ID: 'data-swiper-product-id',
    SWIPER_VARIANT_ID: 'data-swiper-variant-id',
    PRODUCT_DIMENSION_IMAGE: 'data-product-dimension-image',

    // Notify btn related
    NOTIFY_BTN: 'data-notify-btn',
    NOTIFY_BTN_VARIANT_ID: 'data-variant-id',

    // JSON data attributes
    JSON_SIBLING_PRODUCT_ID: 'data-json-sibling-product-id',
    JSON_CART_TITLE: 'data-json-cart-title',
    JSON_ADD_ON_PRODUCT_ID: 'data-json-add-on-product-id',
  },

  // Events
  EVENTS: {
    DOM_CONTENT_LOADED: 'DOMContentLoaded',
    WINDOW_LOAD: 'load',
    WINDOW_RESIZE: 'resize',
    CLICK: 'click',
  },

  // CSS variables
  CSS_VARS: {
    MOVED_SWIPER_TOP: '--moved-swiper-top',
  },

  // CSS classes
  CSS_CLASSES: {
    HIDDEN: 'hidden',
    OPENED: 'opened',
    SELECTED: 'selected',
    STICKY: 'sticky',
    MOVED: 'moved',
    NO_WRAP: 'nowrap',

    VARIANT_OOS: 'variant--oos',
    PDP_ADD_ONS: 'pdp_addons',
    SWATCH_OPTION_TYPE: 'swatch-option-type',
    OVERRIDE: 'override',

    SWIPER_SLIDE: 'swiper-slide',
    SWIPER_HIDDEN_SLIDE: 'swiper-hidden-slide',
  },
};

/**
 * Logger utility class for console output with prefix and conditional logging.
 *
 * @class Logger
 */
class Logger {
  /**
   * Creates a new Logger instance.
   *
   * @constructor
   * @param {boolean} [enabled=false] - Whether logging is enabled for log and warn methods
   * @param {string} [prefix='BaseProduct'] - Prefix to prepend to all log messages
   */
  constructor(enabled = false, prefix = 'BaseProduct') {
    this.enabled = enabled;
    this.prefix = prefix;
  }

  /**
   * Outputs a log message to the console if logging is enabled.
   *
   * @param {...any} args - Arguments to pass to console.log
   * @returns {void}
   */
  log(...args) {
    if (this.enabled) console.log(`[${this.prefix}]`, ...args);
  }

  /**
   * Outputs a warning message to the console if logging is enabled.
   *
   * @param {...any} args - Arguments to pass to console.warn
   * @returns {void}
   */
  warn(...args) {
    if (this.enabled) console.warn(`[${this.prefix}]`, ...args);
  }

  /**
   * Outputs an error message to the console regardless of enabled status.
   *
   * @param {...any} args - Arguments to pass to console.error
   * @returns {void}
   */
  error(...args) {
    console.error(`[${this.prefix}]`, ...args);
  }
}

if (!customElements.get('base-product')) {
  customElements.define(
    'base-product',
    class BaseProduct extends HTMLElement {
      /**
       * Constructor for the BaseProduct class.
       * Initializes product state, configures history scrollRestoration,
       * and sets up necessary data structures.
       *
       * @constructor
       */
      constructor() {
        super();
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

        this.logger = new Logger(false, 'BaseProduct');

        this.state = {
          initialized: false,
          singleVariantSiblings: false,
          product: {},
          variant: {},
          subscription: {},
          maxAddOnsNum: 0,
          isUpdating: false,
        };

        this.jsonProductData = null;
        this.swipers = new Map();
        this.matchAddOnSwatchJson = new Map();
        this.form = null;
        this.summaryElements = {};
      }

      /**
       * Lifecycle method called when the component is added to the DOM.
       * Initializes the component state, sets up UI elements, and prepares product data
       * if the component hasn't been initialized yet.
       *
       * @returns {void}
       */
      connectedCallback() {
        if (this.state.initialized) return;
        this.state.initialized = true;
        this.initState();

        this.onDomReady(() => {
          const productData = this.getJsonData();
          if (productData) this.updateStateFromProductData(productData);

          this.attachListeners();
          this.createSwipers();
          this.initFormAndSummaryElements();
          this.updateDeliveryInfo();
          // this.handleStickyMobileSwiper(); // uncomment if required
        });
      }

      /**
       * State Management
       * @namespace StateManagement
       * Methods for handling application state and related operations
       */

      /**
       * Initializes the component state with default values and any provided attribute overrides.
       * Sets up product, variant, subscription, and add-on data structures.
       *
       * @returns {void}
       */
      initState() {
        // Set default values
        const defaultState = {
          product: {
            id: null,
            titleMain: '',
            titlePreModifier: '',
            titlePostModifier: '',
            specs: [],
            dimensionImage: null,
          },
          variant: {
            id: null,
            ref: null,
            sku: null,
            handle: null,
            name: null,
            featuredImage: null,
            price: null,
            compareAtPrice: null,
            available: false,
            deliveryMessage: '',
            hideNotifyMe: false,
            options: [],
            specs: [],
            featuresSource: '',
          },
          subscription: {
            active: false,
            id: null,
            price: null,
          },
          addOns: new Map(),
          isUpdating: false,
        };

        // Override with attribute values if available
        const attributeState = {
          product: {
            id: this.getAttribute(CONSTANTS.DATA_ATTR.DEFAULT_PRODUCT_ID) || defaultState.product.id,
          },
          variant: {
            id: this.getAttribute(CONSTANTS.DATA_ATTR.DEFAULT_VARIANT_ID) || defaultState.variant.id,
          },
          maxAddOnsNum: parseInt(this.getAttribute(CONSTANTS.DATA_ATTR.MAX_ADD_ONS), 10) || 0,
          singleVariantSiblings: this.hasAttribute(CONSTANTS.DATA_ATTR.SINGLE_VARIANT_SIBLINGS),
        };

        this.state = {
          ...this.state,
          ...defaultState,
          ...attributeState,
          product: {
            ...defaultState.product,
            ...attributeState.product,
          },
          variant: {
            ...defaultState.variant,
            ...attributeState.variant,
          },
          subscription: {
            ...defaultState.subscription,
          },
        };

        this.logger?.log('Init state', this.state);
      }

      /**
       * Updates the state of the component with data from the provided product data object.
       *
       * @param {Object} productData - The product data containing product and variant details.
       * @param {string|number} [selector=this.state.variant.id] - The variant ID or reference used to select a variant.
       *
       * @description
       * This method updates the `state` of the component using the provided product data.
       * It finds the current variant based on the provided selector or defaults to the first variant
       * in the list. The method ensures that proper defaults are set in case data is missing.
       * It also logs warnings if the product data or variants are unavailable.
       *
       * @throws Will log an error if the state update fails due to an exception.
       */
      updateStateFromProductData(productData, selector = this.state.variant.id) {
        if (!productData?.variants) {
          this.logger?.warn('No variants found in product data:', productData);
          return;
        }

        const currentVariant =
          productData.variants.find((variant) => variant.variant_ref === selector || variant.id === selector) ||
          productData.variants[0];

        if (!currentVariant) {
          this.logger?.warn('No variants available in product data');
          return;
        }

        // Store the product data for future reference
        this.jsonProductData = productData;

        try {
          this.state = {
            ...this.state,
            product: {
              ...this.state.product,
              titleMain: productData.title_main || '',
              titlePreModifier: productData.title_pre_modifier || '',
              titlePostModifier: productData.title_post_modifier || '',
              specs: Array.isArray(productData.specs) ? productData.specs : [],
              dimensionImage: productData.dimension_image || null,
            },
            variant: {
              ...this.state.variant,
              id: currentVariant.id || null,
              ref: currentVariant.variant_ref || null,
              handle: currentVariant.handle || null,
              available: currentVariant.available === 'true',
              hideNotifyMe: Boolean(currentVariant.hide_notify_me),
              price: currentVariant.price ? parseInt(currentVariant.price, 10) : null,
              compareAtPrice: currentVariant.compare_at_price ? parseInt(currentVariant.compare_at_price, 10) : null,
              sku: currentVariant.sku || null,
              name: currentVariant.name || null,
              featuredImage: currentVariant.featured_image || null,
              deliveryMessage: currentVariant.delivery_message || '',
              options: Array.isArray(currentVariant.options) ? currentVariant.options : [],
              specs: Array.isArray(currentVariant.specs) ? currentVariant.specs : [],
              featuresSource: currentVariant.features_source || '',
            },
          };

          this.logger?.log(`Updated whole state with product ${this.state.product.id}:`, this.state);
        } catch (error) {
          this.logger?.error('Error updating state:', error);
        }
      }

      /**
       * Updates the state of the component with a new variant based on the provided selector.
       *
       * @param {string|number} [selector=this.state.variant.id] - The variant ID used to select a variant.
       *
       * @description
       * This method updates the `variant` state of the component by finding the corresponding variant
       * in the previously stored `jsonProductData.variants`. If the selector is not provided, it defaults to
       * the current variant ID in the state. The method validates the presence of the product data and the given
       * selector, logging appropriate warnings if they are missing. Once the variant is found, it updates relevant
       * details in the `variant` part of the state.
       *
       * @throws Will log an error if the state update process fails due to an exception.
       */
      updateVariantState(selector = this.state.variant.id) {
        if (!this.jsonProductData?.variants) {
          this.logger?.warn('No product data available for variant update');
          return;
        }

        if (!selector) {
          this.logger?.warn('No selector provided for variant update');
          return;
        }

        const newVariant = this.jsonProductData.variants.find((variant) => variant.id === selector);

        if (!newVariant) {
          this.logger?.warn(`Variant with selector ${selector} not found`);
          return;
        }

        try {
          this.state = {
            ...this.state,
            variant: {
              ...this.state.variant,
              id: newVariant.id || null,
              ref: newVariant.variant_ref || null,
              handle: newVariant.handle || null,
              available: newVariant.available === 'true',
              hideNotifyMe: Boolean(newVariant.hide_notify_me),
              price: newVariant.price ? parseInt(newVariant.price, 10) : null,
              compareAtPrice: newVariant.compare_at_price ? parseInt(newVariant.compare_at_price, 10) : null,
              sku: newVariant.sku || null,
              name: newVariant.name || null,
              featuredImage: newVariant.featured_image || null,
              deliveryMessage: newVariant.delivery_message || '',
              options: Array.isArray(newVariant.options) ? newVariant.options : [],
              specs: Array.isArray(newVariant.specs) ? newVariant.specs : [],
              featuresSource: newVariant.features_source || '',
            },
          };

          this.logger?.log(`Updated variant state to ${newVariant.id}:`, this.state.variant);
        } catch (error) {
          this.logger?.error('Error updating variant state:', error);
        }
      }

      /**
       * Updates the subscription-related state of the component based on the provided button element.
       *
       * @param {HTMLElement|null} [button=null] - The button element which is used to extract subscription attributes.
       *                                            If `null`, the subscription state will be reset.
       *
       * @description
       * This method updates the `subscription` part of the component's state. If a button is provided, it reads the
       * subscription ID and price from the button's attributes and uses them to set the state. If no button is
       * provided, the subscription state will be cleared (made inactive).
       * Appropriate logging is done at each step of the state update process.
       *
       * @example
       * // Example usage with a button element:
       * this.updateSubscriptionState(buttonElement);
       *
       * // Example usage to clear subscription state:
       * this.updateSubscriptionState();
       */
      updateSubscriptionState(button = null) {
        if (!button) {
          this.state.subscription = {
            active: false,
            id: null,
            price: null,
          };

          this.logger?.log('Subscription state cleared');
          return;
        }

        const subscriptionId = button.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_ID) || null;
        const subscriptionPrice = button.hasAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_PRICE)
          ? parseInt(button.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_PRICE), 10)
          : null;

        this.state.subscription = {
          active: true,
          id: subscriptionId,
          price: subscriptionPrice,
        };

        this.logger?.log('Updated subscription state:', this.state.subscription);
      }

      /**
       * Updates the state of add-ons based on the provided button element and add-on index.
       *
       * @param {HTMLElement|null} [button=null] - The button element associated with the add-on. If not provided, all add-ons will be reset.
       * @param {number|null} [addOnIndex=null] - The unique index or key identifying the add-on. If not provided, all add-ons will be reset.
       *
       * @returns {boolean} - Returns `true` if an add-on was added to the state, or `false` if it was removed or the operation failed.
       *
       * @description
       * This method manages the `addOns` part of the state by either adding or removing an add-on based on the provided button's state.
       * If the button is inactive, the add-on data (variant ID, price, compare-at price, etc.) is added to the state.
       * If the button is active, the add-on corresponding to the `addOnIndex` is removed from the state.
       * Logs are generated for each action, providing insights into the state changes or warnings for missing attributes.
       *
       * @example
       * // Example usage to reset all add-ons:
       * this.updateAddOnState();
       *
       * // Example usage to add or remove an add-on:
       * this.updateAddOnState(buttonElement, addOnIndex);
       */
      updateAddOnState(button = null, addOnIndex = null) {
        if (!button || !addOnIndex) {
          this.state.addOns.clear();
          this.logger?.log('Reset add-ons state');

          return false;
        }

        const isButtonActive = this.isButtonActive(button);

        if (isButtonActive) {
          this.state.addOns.delete(addOnIndex);
          this.logger?.log(`Removed add-on ${addOnIndex} from add-ons state`);

          return false;
        } else {
          const addOnVariantId = button.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_VARIANT_ID) || null;
          const addOnPrice = parseInt(button.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_PRICE), 10) || 0;
          const addOnCompareAtPrice =
            parseInt(button.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_COMPARE_AT_PRICE), 10) || 0;

          if (!addOnVariantId) {
            this.logger?.warn('Missing required add-on attributes', {
              addOnVariantId,
            });

            return false;
          }

          this.state.addOns.set(addOnIndex, {
            variantId: addOnVariantId,
            price: addOnPrice,
            compareAtPrice: addOnCompareAtPrice,
            quantity: 1,
          });

          this.logger?.log(`Added add-on ${addOnIndex} to state`, this.state.addOns.get(addOnIndex));
          return true;
        }
      }

      /**
       * Event Listeners
       * @namespace EventListeners
       * Methods for attaching and managing DOM event listeners
       */

      /**
       * Attaches event listeners to different DOM elements to handle user interactions and state updates.
       *
       * - It logs the initialization of the listeners for debugging purposes.
       * - Listeners are attached for sections, dropdowns, document clicks, and window events.
       *
       * @description
       * This method groups the attachment of multiple event listeners into a single call.
       * It acts as an entry point to ensure various sections of the page respond to events
       * related to configuration sections, dropdown menus, document clicks, and window actions.
       */
      attachListeners() {
        this.logger?.log('attachListeners');

        this.attachSectionListeners();
        this.attachDropdownListeners();
        this.attachDocumentListeners();
        this.attachWindowListeners();
      }

      /**
       * Attaches listeners to sections present in the DOM.
       *
       * - Loops through all section elements and adds click event listeners.
       * - Determines if the event target is a valid button within the section.
       * - Handles section-specific interactions like updating button states or processing clicks based on the section type.
       *
       * @description
       * This method ensures that section-based user interactions are handled properly.
       * It skips sections or buttons that are inactive and delegates the appropriate logic
       * to methods like `updateSectionButtonsState` or `handleSectionTypeClick`.
       *
       * @throws {Error} Throws a warning log if no sections are found.
       */
      attachSectionListeners() {
        this.logger?.log('attachSectionListeners');

        const sections = this.querySelectorAll(CONSTANTS.SELECTORS.SECTION);

        if (!sections.length) {
          this.logger?.warn('No sections found');
          return;
        }

        sections.forEach((section) => {
          section.addEventListener(CONSTANTS.EVENTS.CLICK, (event) => {
            const button = event.target.closest(CONSTANTS.SELECTORS.BUTTON);

            if (!button) return;
            if (!this.isSectionActive(section)) return;

            if (section.tagName !== CONSTANTS.SELECTORS.SIBLING_ADD_ONS.toUpperCase()) {
              if (this.isButtonActive(button)) return;
              this.updateSectionButtonsState(section, button);
            }

            this.handleSectionTypeClick(section, button);
          });
        });
      }

      /**
       * Attaches event listeners specifically for dropdown elements on the DOM.
       *
       * - Adds click event listeners to dropdown buttons to toggle their open/close state.
       * - Sets up click listeners on subscription options within the dropdown to handle selections.
       * - Prevents event propagation to avoid undesired behaviors on parent elements.
       * - Logs warnings if no dropdowns or options are found.
       *
       * @description
       * This method handles dropdown-specific interactions by managing the open/close states of dropdown menus
       * and the selection logic for subscription options.
       *
       * @throws {Error} Logs a warning if no dropdowns are found.
       */
      attachDropdownListeners() {
        this.logger?.log('attachDropdownListeners');

        const dropdowns = this.querySelectorAll(CONSTANTS.SELECTORS.DROPDOWN);

        if (!dropdowns.length) {
          this.logger?.warn('No dropdowns found');
          return;
        }

        dropdowns.forEach((dropdown) => {
          const openButton = dropdown.querySelector(CONSTANTS.SELECTORS.DROPDOWN_BUTTON);

          if (openButton) {
            openButton.addEventListener(CONSTANTS.EVENTS.CLICK, (event) => {
              event.stopPropagation();

              if (dropdown.classList.contains(CONSTANTS.CSS_CLASSES.OPENED)) {
                this.closeDropdown(dropdown);
              } else {
                this.openDropdown(dropdown);
              }
            });
          }

          const options = dropdown.querySelectorAll(CONSTANTS.SELECTORS.SUBSCRIPTION_OPTION);

          if (options.length) {
            options.forEach((option) => {
              option.addEventListener(CONSTANTS.EVENTS.CLICK, (e) => {
                e.stopPropagation();
                this.handleSubscriptionOptionClick(option, dropdown);
              });
            });
          }
        });
      }

      /**
       * Attaches a global click listener to the document to handle click-based behaviors.
       *
       * - Removes any previously added click event listener to prevent duplicate listeners.
       * - Delegates click events to the `handleDocumentClick` method for further processing.
       *
       * @description
       * This method ensures proper handling of document-level click interactions
       * by adding or reattaching the necessary click event listener.
       */
      attachDocumentListeners() {
        this.logger?.log('attachDocumentListeners');

        document.removeEventListener(CONSTANTS.EVENTS.CLICK, this.handleDocumentClick);

        document.addEventListener(CONSTANTS.EVENTS.CLICK, (event) => {
          this.handleDocumentClick(event);
        });
      }

      /**
       * Attaches event listeners to the window object.
       *
       * @description
       * This method sets up window-level event listeners for the component,
       * currently handling only the window load event to trigger lazy image loading.
       *
       * The method binds the component instance to the callback function
       * to ensure proper 'this' context when the event handler is invoked.
       */
      attachWindowListeners() {
        this.logger?.log('attachWindowListeners');

        window.addEventListener(CONSTANTS.EVENTS.WINDOW_LOAD, this.loadLazyImagesWithFallback.bind(this));
      }

      /**
       * Click Handlers
       * @namespace ClickHandlers
       * Methods for processing user click interactions
       */

      /**
       * Executes the appropriate handler based on the type of configuration section.
       *
       * @param {Element} section - The configuration section DOM element to handle.
       * @param {Element} button - The clicked button within the configuration section.
       *
       * @description
       * Routes click events to specialized handlers based on the section type:
       * - SIBLING_PRODUCTS: Handles sibling product selection
       * - SIBLING_VARIANTS: Handles variant selection
       * - SIBLING_ADD_ONS: Handles add-on product selection
       *
       * The method uses a mapping object to determine which handler to call based
       * on the section's tag name.
       */
      handleSectionTypeClick(section, button) {
        const handlers = {
          [CONSTANTS.SELECTORS.SIBLING_PRODUCTS.toUpperCase()]: () => this.handleSiblingProductClick(button),
          [CONSTANTS.SELECTORS.SIBLING_VARIANTS.toUpperCase()]: () => this.handleSiblingVariantClick(button),
          [CONSTANTS.SELECTORS.SIBLING_ADD_ONS.toUpperCase()]: () => this.handleAddOnClick(button),
        };

        const handler = handlers[section.tagName];

        if (handler) handler();
      }

      /**
       * Handles the click event for sibling product sections.
       *
       * @param {Element} button - The button element that was clicked.
       *
       * @description
       * This method updates the product state based on the clicked button and performs
       * necessary UI updates.
       *
       * The method includes guards against concurrent updates and error handling.
       */
      handleSiblingProductClick(button) {
        if (this.state.isUpdating) return;
        this.state.isUpdating = true;

        try {
          // TODO: consider adding this.previousState for all previous values required
          //  and managing it via helper like other states
          //  previousFeaturesSource as well
          const previousVariantRef = this.state.variant.ref;
          const wasSubscriptionActive = this.state.subscription.active;

          this.state.product.id = button.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_PRODUCT_ID);
          this.logger?.log('state.product.id from handleSiblingProductClick: ', this.state.product.id);

          const productData = this.getJsonData();
          if (productData) this.updateStateFromProductData(productData, previousVariantRef);

          this.updateSelectedSwatchMeta();

          if (!this.state.singleVariantSiblings) this.updateVariantPickers(wasSubscriptionActive, previousVariantRef);

          this.updateProductMainTitle();

          if (this.state.maxAddOnsNum > 0) {
            this.updateAddOnPickers();
            this.resetAddOns();
          }

          this.updateActiveSwiper();
          this.updateURL();
          this.updateSpecsModal();
          this.updateSelectedVariantJsonEl();

          this.updateFormMainVariantInput();
          this.updateCartSummary();
        } catch (error) {
          this.logger?.error('Error in handleSiblingProductClick:', error);
        } finally {
          this.state.isUpdating = false;
          if (this.state.maxAddOnsNum > 0) this.matchAddOnSwatch(true);
          if (this.state.variant.featuresSource) this.updateProductFeatures();
        }
      }

      /**
       * Handles the click event for sibling variant sections.
       *
       * @param {Element} button - The button element that was clicked.
       *
       * @description
       * Updates the variant state based on the clicked button and performs UI updates.
       *
       * Includes guards against concurrent updates and error handling.
       */
      handleSiblingVariantClick(button) {
        if (this.state.isUpdating) return;
        this.state.isUpdating = true;

        const previousFeaturesSource = this.state.variant.featuresSource;

        try {
          this.state.variant.id = button.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_VARIANT_ID);
          this.logger?.log('state.variant.id from handleSiblingVariantClick: ', this.state.variant.id);

          this.updateVariantState();
          if (button.classList.contains(CONSTANTS.CSS_CLASSES.SWATCH_OPTION_TYPE)) this.updateSelectedSwatchMeta();

          if (this.state.maxAddOnsNum > 0) this.resetAddOns();

          this.updateVariantSlides();
          this.updateURL();
          this.updateSpecsModal(false);
          this.updateSelectedVariantJsonEl();

          const isSubscription = button.hasAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_ID);
          if (isSubscription) {
            this.handleSubscriptionPickerClick(button);
          } else if (this.state.subscription.active) {
            this.resetSubscription();
          }

          this.updateFormMainVariantInput();
          this.updateCartSummary();
        } catch (error) {
          this.logger?.error('Error in handleSiblingVariantClick:', error);
        } finally {
          this.state.isUpdating = false;
          if (this.state.maxAddOnsNum > 0) this.matchAddOnSwatch();
          if (this.state.variant.featuresSource) this.updateProductFeatures(true, previousFeaturesSource);
        }
      }

      /**
       * Handles the click event for subscription picker buttons.
       *
       * @param {Element} button - The subscription picker button element.
       *
       * @description
       * Updates the subscription state based on the clicked button and updates UI.
       */
      handleSubscriptionPickerClick(button) {
        if (!button) {
          this.logger?.warn('No subscription picker button provided');
          return;
        }

        this.updateSubscriptionState(button);
        this.updateFormSubscriptionInput();

        const openedDropdown = button.closest(`${CONSTANTS.SELECTORS.DROPDOWN}.${CONSTANTS.CSS_CLASSES.OPENED}`);
        if (openedDropdown) this.closeDropdown(openedDropdown);
      }

      /**
       * Handles clicks on subscription options within a dropdown.
       *
       * @param {Element} option - The clicked subscription option element
       * @param {Element} dropdown - The parent dropdown element
       *
       * @description
       * Processes subscription option selection and updates UI.
       */
      handleSubscriptionOptionClick(option, dropdown) {
        const optionId = option.getAttribute(CONSTANTS.DATA_ATTR.SUBSCRIPTION_OPTION_ID);

        if (!optionId) {
          this.logger?.warn('No subscription option ID found');
          return;
        }

        const subscriptionPicker = dropdown.querySelector(CONSTANTS.SELECTORS.SUBSCRIPTION_PICKER);

        if (!subscriptionPicker) {
          this.logger?.warn('No matching subscription picker found');
          return;
        }

        subscriptionPicker.setAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_ID, optionId);

        const optionDescriptionEl = option.querySelector(CONSTANTS.SELECTORS.OPTION_DETAILS);
        const pickerDescriptionEl = subscriptionPicker.querySelector(CONSTANTS.SELECTORS.OPTION_DETAILS);

        if (optionDescriptionEl && pickerDescriptionEl) {
          pickerDescriptionEl.textContent = optionDescriptionEl.textContent;
        }

        const optionSummary = option.getAttribute(CONSTANTS.DATA_ATTR.SUBSCRIPTION_OPTION_SUMMARY);
        if (optionSummary) {
          subscriptionPicker.setAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_SUMMARY, optionSummary);
        }

        const optionPrice = option.getAttribute(CONSTANTS.DATA_ATTR.SUBSCRIPTION_OPTION_PRICE);
        if (optionPrice) {
          subscriptionPicker.setAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_PRICE, optionPrice);
        }

        this.closeDropdown(dropdown, subscriptionPicker);
        this.setSelectedOption(dropdown, option);
        this.handleSiblingVariantClick(subscriptionPicker);
      }

      /**
       * Handles click events on add-on buttons.
       *
       * @param {Element} button - The clicked add-on button element
       *
       * @description
       * Manages the add-on selection workflow.
       *
       * Includes error handling and state update safeguards.
       */
      handleAddOnClick(button) {
        if (this.state.isUpdating) return;
        this.state.isUpdating = true;

        try {
          const addOnIndex = parseInt(button.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_INDEX), 10) || null;
          const wasAdded = this.updateAddOnState(button, addOnIndex);

          this.setButtonState(button, wasAdded ? CONSTANTS.STATES.ACTIVE : CONSTANTS.STATES.INITIAL);
          this.updateFormAddOnInputs(addOnIndex);
          this.updateCartSummary(true);
        } catch (error) {
          this.logger?.error('Error in handleAddOnClick:', error);
        } finally {
          this.state.isUpdating = false;
        }
      }

      /**
       * Handles clicks anywhere in the document to close open dropdowns.
       *
       * @param {Event} event - The click event object
       *
       * @description
       * Implements a click-outside behavior for dropdown menus.
       */
      handleDocumentClick(event) {
        const openedDropdowns = this.querySelectorAll(
          `${CONSTANTS.SELECTORS.DROPDOWN}.${CONSTANTS.CSS_CLASSES.OPENED}`
        );

        if (!openedDropdowns.length) return;

        openedDropdowns.forEach((dropdown) => {
          if (!dropdown.contains(event.target)) {
            this.closeDropdown(dropdown);
          }
        });
      }

      /**
       * Subscription Helpers
       * @namespace SubscriptionHelpers
       */

      /**
       * Opens a dropdown element by adding the 'opened' CSS class and updates sibling variant section buttons if they exist.
       * @param {HTMLElement} dropdown - The dropdown element to open
       */
      openDropdown(dropdown) {
        if (!dropdown) return;

        dropdown.classList.add(CONSTANTS.CSS_CLASSES.OPENED);

        const quantityPickersParent = this.querySelector(CONSTANTS.SELECTORS.SIBLING_VARIANTS);

        if (quantityPickersParent) {
          this.updateSectionButtonsState(quantityPickersParent);
        }
      }

      /**
       * Closes a dropdown element by removing the 'opened' CSS class.
       * Optionally updates the state of a subscription picker element.
       *
       * @param {HTMLElement} dropdown - The dropdown element to close.
       * @param {HTMLElement|null} [subscriptionPicker=null] - The subscription picker element to update (optional).
       *
       * @description
       * This method handles the closing of a dropdown menu. If a subscription picker is provided,
       * its state will be updated to the active state. If no subscription picker is provided,
       * the method attempts to locate one in the dropdown and determines its state based on the
       * subscription and quantity picker states.
       */
      closeDropdown(dropdown, subscriptionPicker = null) {
        if (!dropdown) return;

        dropdown.classList.remove(CONSTANTS.CSS_CLASSES.OPENED);

        if (subscriptionPicker) {
          this.setButtonState(subscriptionPicker, CONSTANTS.STATES.ACTIVE);
          return;
        }

        subscriptionPicker = dropdown.querySelector(CONSTANTS.SELECTORS.SUBSCRIPTION_PICKER);

        if (this.state.subscription.active) {
          this.setButtonState(subscriptionPicker, CONSTANTS.STATES.ACTIVE);
        } else {
          const quantityPickers = this.querySelector(CONSTANTS.SELECTORS.SIBLING_VARIANTS)?.querySelectorAll(
            `[${CONSTANTS.DATA_ATTR.BUTTON_STATE}]`
          );
          this.updateSectionButtonsState(quantityPickers, subscriptionPicker);
          this.handleSiblingVariantClick(subscriptionPicker);
        }
      }

      /**
       * Sets the selected option in a dropdown by toggling the 'selected' class.
       * @param {HTMLElement} dropdown - The dropdown containing the options
       * @param {HTMLElement} selectedOption - The option to mark as selected
       */
      setSelectedOption(dropdown, selectedOption) {
        const options = dropdown.querySelectorAll(CONSTANTS.SELECTORS.SUBSCRIPTION_OPTION);

        if (options.length) {
          options.forEach((option) => {
            option.classList.toggle(CONSTANTS.CSS_CLASSES.SELECTED, option === selectedOption);
          });
        }
      }

      /**
       * Resets the subscription by updating the subscription state and form input.
       */
      resetSubscription() {
        this.updateSubscriptionState();
        this.updateFormSubscriptionInput();
      }

      /**
       * Addons Helpers
       * @namespace AddonsHelpers
       */

      /**
       * Resets add-ons by updating their state and form inputs, then updates section button states.
       * Also sets the section state based on variant availability.
       */
      resetAddOns() {
        this.updateAddOnState();
        this.updateFormAddOnInputs();

        const parentEl = this.querySelector(CONSTANTS.SELECTORS.SIBLING_ADD_ONS);
        if (parentEl) {
          this.updateSectionButtonsState(parentEl);
          this.setSectionState(
            parentEl,
            this.state.variant.available ? CONSTANTS.STATES.ACTIVE : CONSTANTS.STATES.INACTIVE
          );
        }
      }

      /**
       * Matches add-on swatches with the current variant and updates their display accordingly.
       * If no data is found in the cache, fetches JSON data for matching.
       * @param {boolean} [findData=false] - Whether to fetch new JSON data regardless of cache status
       * @returns {void}
       */
      matchAddOnSwatch(findData = false) {
        const addOnToMatches = this.querySelectorAll(
          `[${CONSTANTS.DATA_ATTR.ADD_ON_MATCH_SWATCH}][${CONSTANTS.DATA_ATTR.SIBLING_PRODUCT_ID}="${this.state.product.id}"]`
        );

        if (!addOnToMatches.length) {
          this.matchAddOnSwatchJson.clear();
          this.logger?.log('No add-ons to match swatches for.');
          return;
        }

        if (!findData && this.matchAddOnSwatchJson.size === 0) {
          findData = true;
          this.logger?.log('Fetching JSON data because Map is empty');
        }

        if (findData) {
          const jsonDataMap = new Map();
          for (const addOnToMatch of addOnToMatches) {
            const addOnProductId = addOnToMatch.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_PRODUCT_ID);
            const addOnIndex = parseInt(addOnToMatch.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_INDEX), 10);

            const addOnJsonData = this.getJsonData(
              this.state.product.id,
              CONSTANTS.DATA_ATTR.SIBLING_PRODUCT_ID,
              addOnProductId,
              CONSTANTS.DATA_ATTR.JSON_ADD_ON_PRODUCT_ID
            );

            if (addOnJsonData) {
              jsonDataMap.set(addOnIndex, addOnJsonData);
              this.logger?.log('Add-on data found for:', addOnProductId);
            }
          }

          this.matchAddOnSwatchJson = jsonDataMap;
        }

        for (const addOnToMatch of addOnToMatches) {
          const addOnIndex = parseInt(addOnToMatch.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_INDEX), 10);
          const addOnProductId = addOnToMatch.getAttribute(CONSTANTS.DATA_ATTR.ADD_ON_PRODUCT_ID);
          const addOnParent = addOnToMatch.closest(CONSTANTS.SELECTORS.ADD_ON_WRAPPER);

          const addonData = this.matchAddOnSwatchJson.get(addOnIndex);

          if (!addonData) {
            this.logger?.log(`No addon data found for index ${addOnIndex}`);
            continue;
          }

          const matchedSwatchVariant = addonData.find((variant) => variant.swatch_value === this.state.variant.ref);

          if (!matchedSwatchVariant) {
            this.logger?.log(`No matching variant found for swatch value ${this.state.variant.ref}`);
            addOnParent.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
            continue;
          }

          this.logger?.log(`matchedSwatchVariant`, matchedSwatchVariant);

          this.updateAddOnWithMatchedVariant(addOnToMatch, addOnParent, matchedSwatchVariant, addOnProductId);
        }
      }

      /**
       * Updates an add-on element with matched variant data.
       * @param {HTMLElement} addOnElement - The add-on element to update
       * @param {HTMLElement} parentElement - The parent wrapper element
       * @param {Object} variantData - The matched variant data
       * @param {string} variantData.variant_id - The variant ID
       * @param {string} variantData.swatch_value - The swatch value
       * @param {string} variantData.price - The variant price
       * @param {string} variantData.compare_at_price - The variant compare-at price
       * @param {string} variantData.override_image - The variant image URL
       * @param {string} productId - The product ID
       * @returns {void}
       */
      updateAddOnWithMatchedVariant(addOnElement, parentElement, variantData, productId) {
        const addOnDetailsEl = addOnElement.querySelector(CONSTANTS.SELECTORS.OPTION_DETAILS);
        const previewImgEl = parentElement.querySelector(
          `[${CONSTANTS.DATA_ATTR.PREVIEW_IMAGE_PRODUCT_ID}="${productId}"] img`
        );

        const variantId = variantData.variant_id;
        const swatchValue = variantData.swatch_value;
        const variantPrice = variantData.price;
        const variantCompareAtPrice = variantData.compare_at_price;
        const newPreviewImgSrc = variantData.override_image;

        addOnElement.setAttribute(CONSTANTS.DATA_ATTR.ADD_ON_VARIANT_ID, variantId);
        addOnElement.setAttribute(CONSTANTS.DATA_ATTR.ADD_ON_PRICE, variantPrice);
        addOnElement.setAttribute(CONSTANTS.DATA_ATTR.ADD_ON_COMPARE_AT_PRICE, variantCompareAtPrice);

        if (addOnDetailsEl && swatchValue) {
          this.updateAddOnDetailsText(addOnDetailsEl, swatchValue, variantPrice);
        }

        if (previewImgEl && newPreviewImgSrc) {
          previewImgEl.src = newPreviewImgSrc;
          previewImgEl.setAttribute('data-src', newPreviewImgSrc);
        }

        parentElement.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
      }

      /**
       * Updates the text content of an add-on details element with new swatch value and price.
       * @param {HTMLElement} detailsElement - The element containing the details text
       * @param {string} swatchValue - The new swatch value to display
       * @param {string} price - The price
       * @returns {void}
       */
      updateAddOnDetailsText(detailsElement, swatchValue, price) {
        const detailsParts = detailsElement.textContent.split('|');
        let formattedSwatchValue = '';
        if (swatchValue) {
          formattedSwatchValue = swatchValue
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
        }
        if (detailsParts.length === 2) {
          detailsParts[0] = formattedSwatchValue;
          detailsParts[1] = `${this.formatCurrency(parseFloat(price) / 100)}`;
        } else if (detailsParts.length === 3) {
          detailsParts[1] = formattedSwatchValue;
          detailsParts[2] = `${this.formatCurrency(parseFloat(price) / 100)}`;
        }

        detailsElement.textContent = detailsParts.join(' | ');
      }

      /**
       * UI and Product or Variant selection related updates
       * @namespace ProductUIandRelatedStuff
       */

      /**
       * Updates the product title in all title elements.
       * Combines main title with optional modifiers wrapped in no-wrap span.
       * @returns {void}
       */
      updateProductMainTitle() {
        this.logger?.log('updateProductMainTitle');

        let title = '';

        if (this.state.product.titlePreModifier) {
          title += `<span class="${CONSTANTS.CSS_CLASSES.NO_WRAP}">${this.state.product.titlePreModifier}</span> `;
        }

        title += this.state.product.titleMain;

        if (this.state.product.titlePostModifier) {
          title +=
            ` <span class="${CONSTANTS.CSS_CLASSES.NO_WRAP}">` + this.state.product.titlePostModifier + '</span>';
        }

        const titleDivs = this.querySelectorAll(CONSTANTS.SELECTORS.TITLE_EL);

        titleDivs.forEach((div) => {
          div.innerHTML = title;
        });
      }

      /**
       * Updates variant pickers based on current product/variant state and previous subscription status.
       * Shows/hides pickers based on the current product, and sets the appropriate active picker.
       * @param {boolean} [wasSubscriptionActive=false] - Whether a subscription was previously active
       * @param {string|null} [previousVariantRef=null] - Reference to the previously selected variant
       * @returns {void}
       */
      updateVariantPickers(wasSubscriptionActive = false, previousVariantRef = null) {
        this.logger?.log('updateVariantPickers');
        this.logger?.log('wasSubscriptionActive', wasSubscriptionActive);
        this.logger?.log('previousVariantRef', previousVariantRef);

        const parentEl = this.querySelector(CONSTANTS.SELECTORS.SIBLING_VARIANTS);
        if (!parentEl) return;

        const pickers = parentEl.querySelectorAll(CONSTANTS.SELECTORS.BUTTON);
        const currentProductId = this.state.product.id;
        const currentVariantId = this.state.variant.id;

        let defaultActivePicker = null;
        let subscriptionActivePicker = null;

        pickers.forEach((picker) => {
          const isCurrentProduct = picker.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_PRODUCT_ID) === currentProductId;
          const isCurrentVariant = picker.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_VARIANT_ID) === currentVariantId;
          const isPreviousVariantRef =
            picker.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_VARIANT_REF) === previousVariantRef;
          const isSubscriptionPicker = picker.hasAttribute(CONSTANTS.DATA_ATTR.SIBLING_SUBSCRIPTION_ID);
          const subscriptionDropdown = picker.closest(CONSTANTS.SELECTORS.DROPDOWN);

          if (isCurrentProduct) {
            picker.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
            if (subscriptionDropdown) subscriptionDropdown.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
          } else {
            picker.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
            if (subscriptionDropdown) subscriptionDropdown.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
          }

          if (isCurrentProduct && isCurrentVariant && !isSubscriptionPicker) {
            defaultActivePicker = picker;
          }

          if (isCurrentProduct && isPreviousVariantRef && isSubscriptionPicker && !subscriptionActivePicker) {
            subscriptionActivePicker = picker;
          }
        });

        if (wasSubscriptionActive && subscriptionActivePicker) {
          this.logger?.log('Selecting subscription picker due to previous subscription selection');
          this.updateSectionButtonsState(parentEl, subscriptionActivePicker);
          this.updateSubscriptionState(subscriptionActivePicker);
          this.handleSubscriptionPickerClick(subscriptionActivePicker);
        } else if (defaultActivePicker) {
          this.logger?.log('Selecting regular variant picker');
          this.updateSectionButtonsState(parentEl, defaultActivePicker);
          if (wasSubscriptionActive) this.resetSubscription();
        }
      }

      /**
       * Updates add-on pickers to show/hide based on the current product.
       * @returns {void}
       */
      updateAddOnPickers() {
        this.logger?.log('updateAddOnPickers');

        const parentEl = this.querySelector(CONSTANTS.SELECTORS.SIBLING_ADD_ONS);
        if (!parentEl) return;

        const pickers = parentEl.querySelectorAll(CONSTANTS.SELECTORS.BUTTON);
        const currentProductId = this.state.product.id;

        pickers.forEach((picker) => {
          const isCurrentProduct = picker.getAttribute(CONSTANTS.DATA_ATTR.SIBLING_PRODUCT_ID) === currentProductId;
          const wrapper = picker.closest(CONSTANTS.SELECTORS.ADD_ON_WRAPPER);

          if (isCurrentProduct) {
            wrapper.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
          } else {
            wrapper.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
          }
        });
      }

      /**
       * Updates the selected swatch meta text based on variant state.
       * Uses options[0] for sibling products pickers or variant ref for variants pickers.
       * @returns {void}
       */
      updateSelectedSwatchMeta() {
        const selectedSwatchValueEl = this.querySelector(CONSTANTS.SELECTORS.SELECTED_SWATCH);

        if (!selectedSwatchValueEl) return;

        if (selectedSwatchValueEl.closest(CONSTANTS.SELECTORS.SIBLING_PRODUCTS)) {
          selectedSwatchValueEl.textContent = this.state.variant.options[0];
        } else {
          selectedSwatchValueEl.textContent = this.state.variant.ref;
        }
      }

      /**
       * Updates the browser URL to reflect the current product and variant state.
       * Adds variant parameter only when not dealing with single variant siblings.
       * @returns {void}
       */
      updateURL() {
        this.logger?.log('updateURL');

        const handle = this.state.variant.handle;
        let variantParam = '';

        if (!this.state.singleVariantSiblings) {
          variantParam = `?variant=${this.state.variant.id}`;
        }

        const normalizedHandle = handle.replace('-with-personalization', '');
        const localSubfolder = window.theme.local_subfolder;
        const routes = Shopify.routes;
        if (normalizedHandle) {
          window.history.replaceState(
            { ...window.history.state },
            '',
            `${routes.root}products/${normalizedHandle}${variantParam}`
          );

          this.logger?.log(`Updated URL to: ${normalizedHandle}${variantParam}`);
        }
      }

      /**
       * Updates the data for the selected variant by modifying the CONSTANTS.SELECTORS.SELECTED_VARIANT_DATA element's content.
       * Uses the component's state as data source.
       *
       * @returns {void}
       */
      updateSelectedVariantJsonEl() {
        const selectedVariantDataEl = document.querySelector(CONSTANTS.SELECTORS.SELECTED_VARIANT_DATA);

        if (!selectedVariantDataEl || !this.state.variant.id) {
          this.logger?.log('No selected variant element or variant ID found');
          return;
        }

        const selectedVariantSchema = {
          id: this.state.variant.id,
          name: this.state.variant.name,
          featured_image: {
            src: this.state.variant.featuredImage,
          },
          price: this.state.variant.price,
          compare_at_price: this.state.variant.compareAtPrice,
        };

        selectedVariantDataEl.innerHTML = JSON.stringify(selectedVariantSchema);
        this.logger?.log('Updated selected variant schema from state data:', selectedVariantSchema);
      }

      /**
       * Updates the product features section based on the current variant.
       * Uses the featuresSource property to determine whether to fetch variant-specific
       * or product-level features. The method fetches the appropriate HTML, replaces
       * the existing section in the DOM, and re-initializes lazy loading and product
       * feature scripts.
       *
       * Behavior based on featuresSource:
       * - 'variant': Fetches variant-specific features by adding variant parameter to URL
       * - 'product': Fetches product-level features without variant parameter
       * - If featuresSource is falsy or handle is missing, the method returns early
       *
       * The method also includes optimization logic to avoid unnecessary fetches when
       * switching between variants that both use product-level features.
       *
       * @param {boolean} isVariantClick - Indicates if the update was triggered by a variant selection
       * @param {string} previousFeaturesSource - The featuresSource value of the previously selected variant
       * @returns {void} - This method doesn't return a value
       * @throws {Error} - Errors during fetch are logged but not thrown to the caller
       */
      updateProductFeatures(isVariantClick = false, previousFeaturesSource = '') {
        const handle = this.state.variant.handle;
        const featuresSource = this.state.variant.featuresSource;

        this.logger?.log(`updateProductFeatures`, featuresSource, isVariantClick, previousFeaturesSource);

        if (!handle) return;

        if (isVariantClick && previousFeaturesSource === 'product' && featuresSource === 'product') {
          this.logger?.log(
            'Skipping variant features update because they are product-level for current and previous variants.'
          );
          return;
        }

        let fetchUrl = `/products/${handle}?section_id=product-features`;
        const variantId = this.state.variant.id;

        if (featuresSource === 'variant' && variantId) {
          fetchUrl += `&variant=${variantId}`;
          this.logger?.log(`Fetching variant-specific features for handle: ${handle}, variant: ${variantId}`);
        } else {
          this.logger?.log(`Fetching product-level features for handle: ${handle}`);
        }

        fetch(fetchUrl)
          .then((response) => response.text())
          .then((data) => {
            const html = new DOMParser().parseFromString(data, 'text/html');
            const newFeatures = html.querySelector(CONSTANTS.SELECTORS.PRODUCT_FEATURES);

            if (newFeatures) {
              const oldFeatures = document.querySelector(CONSTANTS.SELECTORS.PRODUCT_FEATURES);

              if (oldFeatures) {
                oldFeatures.replaceWith(newFeatures);

                if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
                  window.lazyLoadInstance.update(
                    document.querySelectorAll(
                      `${CONSTANTS.SELECTORS.PRODUCT_FEATURES} ${CONSTANTS.SELECTORS.LAZY_IMAGE}`
                    )
                  );
                }

                if (window.reinitProductFeaturesScripts && typeof window.reinitProductFeaturesScripts === 'function') {
                  window.reinitProductFeaturesScripts();
                }

                this.logger?.log('Product features section updated successfully');
              }
            }
          })
          .catch((error) => {
            this.logger?.error(`Error fetching product features for handle: ${handle}`, error);
          });
      }

      /**
       * Updates the specifications modal with data from the current product and variant.
       *
       * This method populates the modal with:
       * - Variant-specific specs (material, warranty, SKU, coating)
       * - Product-level specs (capacity, liner code, power source, etc.)
       * - Updates the dimension image to match the current product
       *
       * @param {boolean} [fullUpdate=true] - Whether to update all specs (true) or just variant-specific specs (false)
       */
      updateSpecsModal(fullUpdate = true) {
        this.logger?.log('updateSpecsModal', fullUpdate ? 'full update' : 'variant update');

        const specsModal = document.querySelector(CONSTANTS.SELECTORS.SPECS_MODAL);

        if (!specsModal) {
          this.logger?.log('specsModal not found');
          return;
        }

        const variantSpecs = Array.isArray(this.state.variant.specs) ? this.state.variant.specs : [];

        // this.updateModalField(
        //   specsModal,
        //   CONSTANTS.SELECTORS.SPEC_VARIANT_MATERIAL,
        //   this.findSpecValue(variantSpecs, 'material:')
        // );
        this.updateModalField(
          specsModal,
          CONSTANTS.SELECTORS.SPEC_VARIANT_WARRANTY,
          this.findSpecValue(variantSpecs, 'warranty:')
        );
        this.updateModalField(specsModal, CONSTANTS.SELECTORS.SPEC_VARIANT_SKU, this.state.variant.sku || '');
        this.updateModalField(specsModal, CONSTANTS.SELECTORS.SPEC_VARIANT_COATING, this.state.variant.ref || '');

        const customVariantSpecs = variantSpecs.filter((spec) => spec?.custom_title);
        this.updateCustomSpecs(specsModal, customVariantSpecs);

        if (fullUpdate) {
          const productSpecs = Array.isArray(this.state.product.specs) ? this.state.product.specs : [];

          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_CAPACITY,
            this.findSpecValue(productSpecs, 'capacity:')
          );
          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_LINERCODE,
            this.findSpecValue(productSpecs, 'liner code:')
          );
          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_POWER_SOURCE,
            this.findSpecValue(productSpecs, 'power source:')
          );
          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_INGREDIENTS,
            this.findSpecValue(productSpecs, 'ingredients:')
          );
          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_MAGNIFICATION,
            this.findSpecValue(productSpecs, 'magnification:')
          );
          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_COMPATIBILITY,
            this.findSpecValue(productSpecs, 'compatibility:')
          );
          this.updateModalField(
            specsModal,
            CONSTANTS.SELECTORS.SPEC_PRODUCT_BATTERY_LIFE,
            this.findSpecValue(productSpecs, 'battery life:')
          );

          const customProductSpecs = productSpecs.filter((spec) => spec?.custom_title);
          this.updateCustomSpecs(specsModal, customProductSpecs, 'product');

          if (this.state.product.dimensionImage) {
            this.updateModalImage(specsModal, CONSTANTS.SELECTORS.DIMENSION_IMAGE, this.state.product.dimensionImage);
          }

          this.logger?.log('Modal updated successfully');
        }
      }

      /**
       * Helper method to find a specification value by title from an array of specs
       *
       * @param {Array} specs - Array of specification objects with title and value properties
       * @param {string} title - The title of the specification to find
       * @returns {string} The found specification value or empty string
       */
      findSpecValue(specs, title) {
        const spec = specs.find((spec) => spec?.title === title);
        return spec?.value || '';
      }

      /**
       * Helper method to update content in a modal field
       *
       * @param {Element} modal - The modal element
       * @param {string} selector - CSS selector for the field to update
       * @param {string} content - New content to set
       */
      updateModalField(modal, selector, content) {
        const element = modal.querySelector(selector);
        if (element) {
          element.innerHTML = content;
          this.logger?.log(`Updated ${selector} with:`, content);
        } else {
          this.logger?.warn(`Field not found: ${selector}`);
        }
      }

      /**
       * Creates a specification field DOM element based on the provided spec data.
       *
       * @param {Object} spec - The specification object containing title and value.
       * @param {string} spec.custom_title - The title of the specification field.
       * @param {string} spec.value - The value of the specification field.
       * @param {string} type - The type attribute to add to the data attribute of the specification field.
       * @returns {HTMLElement|undefined} - The created specification field DOM element or undefined if invalid inputs are provided.
       */
      createSpecField(spec, type) {
        if (!spec || !spec.custom_title || !spec.value) return;

        const title = spec.custom_title;
        const value = spec.value || '';

        const specDiv = document.createElement('div');
        specDiv.classList.add(CONSTANTS.SELECTORS.SPEC_FIELD);
        specDiv.setAttribute(`data-${type}-custom-spec`, title);

        const titleDiv = document.createElement('div');
        titleDiv.classList.add(CONSTANTS.SELECTORS.SPEC_TITLE);
        titleDiv.textContent = `${title.replaceAll('-', ' ')}:`;

        const valueDiv = document.createElement('div');
        valueDiv.classList.add(CONSTANTS.SELECTORS.SPEC_VALUE);
        valueDiv.textContent = value;

        specDiv.appendChild(titleDiv);
        specDiv.appendChild(valueDiv);

        return specDiv;
      }

      /**
       * Updates the custom specifications displayed in a modal based on provided specs.
       *
       * This method updates or creates custom specification fields in a modal based on the provided
       * specs array. It handles adding new specs, updating existing ones, and hiding specs that
       * are no longer needed.
       *
       * @param {HTMLElement} modal - The modal DOM element containing the specification fields.
       * @param {Array<Object>} specs - An array of specification objects to be displayed.
       *   Each spec object should contain at least a `custom_title` property and optionally a `value` property.
       *   Specs without a `custom_title` property will be ignored.
       * @param {string} [type='variant'] - The type of specifications being updated.
       *   This affects the CSS selectors and data attributes used. Default is 'variant'.
       *
       * @notes
       * - Existing fields not present in the new specs array will be hidden rather than removed.
       * - Fields are identified by their data-[type]-custom-spec attribute matching the spec's custom_title.
       * - Depends on the CONSTANTS.CSS_CLASSES.HIDDEN constant for hiding unused fields.
       */
      updateCustomSpecs(modal, specs, type = 'variant') {
        if (!Array.isArray(specs)) {
          specs = [];
        }

        const customSpecsContainer = modal.querySelector(`.specs-${type}-custom-container`);
        if (!customSpecsContainer) {
          this.logger?.warn(`Custom specs container for ${type} not found`);
          return;
        }

        // create an object to track existing html fields for custom specs in modal
        const existingFields = {};
        const specFields = modal.querySelectorAll(`[data-${type}-custom-spec]`);
        specFields.forEach((field) => {
          const specTitle = field.getAttribute(`data-${type}-custom-spec`);
          existingFields[specTitle] = field;
        });

        specs.forEach((spec) => {
          if (!spec?.custom_title) return;

          const specTitle = spec.custom_title;

          // if a spec is existed in state and already has html for itself - just update it
          if (existingFields[specTitle]) {
            existingFields[specTitle].querySelector(`.${CONSTANTS.SELECTORS.SPEC_VALUE}`).textContent =
              spec.value || '';
            existingFields[specTitle].classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN); // if was hidden before
            delete existingFields[specTitle]; // delete from the tracking object
          } else {
            // if a spec is existed in state but doesn't have html for itself - create new field
            const newField = this.createSpecField(spec, type);
            if (newField) {
              customSpecsContainer.appendChild(newField);
              this.logger?.log(`Created new custom spec field for: ${specTitle}`);
            }
          }
        });

        // hide all remaining fields, which are presented in modal, but don't have specs data in state to be updated
        Object.values(existingFields).forEach((field) => {
          field.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
          this.logger?.log(`Hiding spec field: ${field.getAttribute(`data-${type}-custom-spec`)}`);
        });
      }

      /**
       * Helper method to update an image in the modal
       *
       * @param {Element} modal - The modal element
       * @param {string} selector - CSS selector for the picture element
       * @param {string} newSrc - New image source URL
       */
      updateModalImage(modal, selector, newSrc) {
        if (!newSrc) {
          this.logger?.warn(`No image source provided for ${selector}`);
          return;
        }

        const pictureEl = modal.querySelector(selector);
        if (!pictureEl) {
          this.logger?.warn(`Picture element not found: ${selector}`);
          return;
        }

        pictureEl.querySelectorAll('source').forEach((source) => {
          source.setAttribute('data-srcset', newSrc);
          source.setAttribute('srcset', newSrc);
        });

        const imgEl = pictureEl.querySelector('img');
        if (imgEl) {
          imgEl.setAttribute('data-src', newSrc);
          imgEl.setAttribute('src', newSrc);
        }
      }

      /**
       * Form Management
       * @namespace FormUpdating
       */

      /**
       * Initializes form and cart summary elements by querying the DOM and storing references.
       * Sets up the form element and a collection of summary-related elements for later use.
       *
       * @returns {void}
       */
      initFormAndSummaryElements() {
        this.logger?.log('Initializing form and cart elements');

        this.form = this.querySelector(CONSTANTS.SELECTORS.FORM);
        if (!this.form) {
          this.logger?.warn('Form not found');
        }

        this.summaryElements = {
          summaryContainer: this.querySelector(CONSTANTS.SELECTORS.BASE_CART_SUMMARY),
          formWrapper: this.querySelector(CONSTANTS.SELECTORS.FORM_WRAPPER),
          totalPrice: this.querySelector(CONSTANTS.SELECTORS.CART_TOTAL_PRICE),
          compareAtTotalPrice: this.querySelector(CONSTANTS.SELECTORS.CART_TOTAL_COMPARE_PRICE),
          addToCartButton: this.querySelector(CONSTANTS.SELECTORS.ADD_TO_CART_BUTTON),
          addToCartButtonText: this.querySelector(CONSTANTS.SELECTORS.ADD_TO_CART_BUTTON_TEXT),
          notifyButton: this.querySelector(CONSTANTS.SELECTORS.NOTIFY_ME_BUTTON),
          deliveryMessage: this.querySelector(CONSTANTS.SELECTORS.DELIVERY_MESSAGE),
          deliveryAccent: this.querySelector(CONSTANTS.SELECTORS.DELIVERY_ACCENT),
          freeShippingText: this.querySelector(CONSTANTS.SELECTORS.DELIVERY_FREE_SHIPPING_TEXT),
          deliveryMessagePropsInput: document.getElementById(CONSTANTS.SELECTORS.DELIVERY_MESSAGE_PROPERTIES_ID),
          bisModalVariantId: document.getElementById(CONSTANTS.SELECTORS.BIS_VARIANT_ID),
        };
      }

      /**
       * Updates the main variant input field in the form with the current variant ID.
       *
       * @returns {void}
       */
      updateFormMainVariantInput() {
        if (!this.form) {
          this.logger?.error('Form not found for updating variant');
          return;
        }

        const input = this.form.querySelector(CONSTANTS.SELECTORS.MAIN_VARIANT_INPUT);

        if (!input) {
          this.logger?.error('Variant ID input not found in form');
          return;
        }

        input.value = this.state.variant.id;
        this.logger?.log('Updated main variant ID in form:', this.state.variant.id);
      }

      /**
       * Updates the subscription input field in the form based on current subscription state.
       * Sets the input value to the subscription ID when active, or clears it otherwise.
       *
       * @returns {void}
       */
      updateFormSubscriptionInput() {
        if (!this.form) {
          this.logger?.error('Form not found for updating subscription');
          return;
        }

        const input = this.querySelector(CONSTANTS.SELECTORS.SUBSCRIPTION_INPUT);

        if (this.state.subscription.active && this.state.subscription.id) {
          input.value = this.state.subscription.id;
          this.logger?.log(`Updated subscription input with ID: ${this.state.subscription.id}`);
        } else {
          input.value = '';
          this.logger?.log('Cleared subscription input');
        }
      }

      /**
       * Updates add-on inputs in the form based on the current state.
       * - If no index is provided, removes all add-on inputs
       * - If index is provided but no add-on exists at that index, removes any inputs for that index
       * - If index is provided with a valid add-on, creates and appends inputs for variant ID and quantity
       *
       * @param {number|null} index - The index of the add-on to update, or null to clear all add-ons
       * @returns {void}
       */
      updateFormAddOnInputs(index = null) {
        if (!this.form) {
          this.logger?.error('Form not found for updating add-ons');
          return;
        }

        if (!index) {
          const allInputs = this.form.querySelectorAll(CONSTANTS.SELECTORS.ADD_ON_INPUT);
          this.logger?.log('allInputs', allInputs);

          if (allInputs.length) {
            allInputs.forEach((input) => input.remove());
            this.logger?.log('Removed all existing add-on inputs');
          }

          return;
        }

        const existingInputs = this.form.querySelectorAll(`input[name^="items[${index}]"]`);
        if (existingInputs.length) {
          existingInputs.forEach((input) => input.remove());

          this.logger?.log(`Removed existing add-on inputs for index ${index}`);
          return;
        }

        const addOn = this.state.addOns.get(index);

        if (addOn) {
          const idInput = this.createFormHiddenInput(
            `items[${index}][id]`,
            addOn.variantId,
            CONSTANTS.CSS_CLASSES.PDP_ADD_ONS
          );

          const quantityInput = this.createFormHiddenInput(
            `items[${index}][quantity]`,
            addOn.quantity,
            CONSTANTS.CSS_CLASSES.PDP_ADD_ONS
          );

          this.form.appendChild(idInput);
          this.form.appendChild(quantityInput);
        }
      }

      /**
       * Cart summary Management
       * @namespace CartSummaryUpdating
       */

      /**
       * Updates the cart summary with current pricing and availability information.
       * Calculates totals and optionally updates button states and delivery information.
       *
       * @param {boolean} skipButtonsAndDelivery - When true, skips updating button states and delivery info
       * @returns {void}
       */
      updateCartSummary(skipButtonsAndDelivery = false) {
        this.logger?.log('updateCartSummary');

        const summaryTotals = this.calculateCartSummaryTotals();
        this.updateCartSummaryTotals(summaryTotals);

        if (!skipButtonsAndDelivery) {
          this.updateAddToCartButtonState();
          this.updateDeliveryInfo();
        }
      }

      /**
       * Updates the add-to-cart button state based on product availability.
       * - Handles visibility of notify-me button for out-of-stock products
       * - Sets appropriate button text and disabled state
       * - Manages form wrapper visibility
       *
       * @returns {void}
       */
      updateAddToCartButtonState() {
        this.logger?.log('updateAddToCartButtonState');

        if (!this.summaryElements.addToCartButton) return;

        if (!this.state.variant.available) {
          if (this.state.variant.hideNotifyMe) {
            this.summaryElements.formWrapper?.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
            this.summaryElements.notifyButton?.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
          } else {
            this.summaryElements.formWrapper?.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
            this.summaryElements.notifyButton?.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
          }

          this.summaryElements.addToCartButton.setAttribute('disabled', 'disabled');
          this.summaryElements.addToCartButtonText.textContent = window.variantStrings.soldOut;
        } else {
          this.summaryElements.addToCartButton.removeAttribute('disabled');
          this.summaryElements.addToCartButtonText.textContent = window.variantStrings.addToCart;
          this.summaryElements.formWrapper?.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
          this.summaryElements.notifyButton?.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
        }
      }

      /**
       * Calculates the total price values for the cart summary.
       * Computes regular and compare-at prices based on the current variant,
       * subscription status, and any added add-ons.
       *
       * @returns {{totalValue: number, compareAtTotalValue: number}} Object containing the calculated totals
       */
      calculateCartSummaryTotals() {
        this.logger?.log('calculateCartSummaryTotals');

        let totalPrice = 0;
        let compareAtTotalPrice = 0;

        if (this.state.subscription.active) {
          totalPrice = this.state.subscription.price / 100;
        } else {
          totalPrice = this.state.variant.price / 100;
        }

        if (this.state.variant.compareAtPrice) {
          compareAtTotalPrice = this.state.variant.compareAtPrice / 100;
        }

        if (this.state.maxAddOnsNum > 0) {
          const addOnTotals = this.calculateAddOnTotals();
          totalPrice += addOnTotals.totalValue;
          compareAtTotalPrice += addOnTotals.compareAtTotalValue;
        }

        this.updateFreeShippingThresholdText(totalPrice);

        return {
          totalValue: totalPrice,
          compareAtTotalValue: compareAtTotalPrice,
        };
      }

      /**
       * Calculates the total price values for all add-ons.
       * Iterates through all add-ons in the current state and sums their prices.
       *
       * @returns {{totalValue: number, compareAtTotalValue: number}} Object containing the calculated add-on totals
       */
      calculateAddOnTotals() {
        this.logger?.log('calculateAddOnTotals');

        let totalPrice = 0;
        let compareAtTotalPrice = 0;

        this.state.addOns.forEach((addOn) => {
          totalPrice += addOn.price / 100;
          compareAtTotalPrice += addOn.compareAtPrice / 100;
        });

        return {
          totalValue: totalPrice,
          compareAtTotalValue: compareAtTotalPrice,
        };
      }

      /**
       * Updates the displayed cart summary totals in the UI.
       * Sets the formatted currency values and manages visibility of compare-at price.
       *
       * @param {Object} cartSummary - The summary object containing total values
       * @param {number} cartSummary.totalValue - The current total price value
       * @param {number} cartSummary.compareAtTotalValue - The compare-at total price value
       * @returns {void}
       */
      updateCartSummaryTotals(cartSummary) {
        this.logger?.log('updateCartSummaryTotals');

        if (!this.summaryElements.totalPrice || !this.summaryElements.compareAtTotalPrice) return;

        this.summaryElements.totalPrice.textContent = this.formatCurrency(cartSummary.totalValue);
        this.summaryElements.compareAtTotalPrice.textContent = this.formatCurrency(cartSummary.compareAtTotalValue);

        this.summaryElements.compareAtTotalPrice.classList.toggle(
          CONSTANTS.CSS_CLASSES.HIDDEN,
          cartSummary.compareAtTotalValue <= cartSummary.totalValue
        );
      }

      /**
       * Formats a numeric amount as currency based on the shop's locale and currency settings.
       * Automatically determines whether to display decimal places based on the amount.
       *
       * @param {number} amount - The monetary amount to format
       * @returns {string} The formatted currency string
       */
      formatCurrency(amount) {
        return new Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active,
          minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(amount);
      }

      /**
       * Updates the free shipping threshold text based on the total price.
       *
       * @param {number} totalPrice - The current total price value
       * @returns {void}
       */
      updateFreeShippingThresholdText(totalPrice) {
        if (totalPrice >= window.theme.ships_free_threshold && this.summaryElements.freeShippingText) {
          this.summaryElements.freeShippingText.textContent = window.theme.ships_free;
        } else if (this.summaryElements.freeShippingText) {
          this.summaryElements.freeShippingText.textContent = window.theme.ships_free_under_threshold;
        }
      }
      /**
       * Updates the delivery information message based on product type and availability.
       * Displays different messages for gift cards, out-of-stock items, and regular products.
       *
       * @returns {void}
       */
      updateDeliveryInfo() {
        this.logger?.log('updateDeliveryInfo');
        const { variant } = this.state;

        if (this.isGiftCard(variant.sku)) {
          this.showGiftCardDeliveryMessage();
        } else if (!variant.available) {
          this.updateBisModalInputs();
          this.showOutOfStockMessage();
        } else if (variant.deliveryMessage) {
          this.showCustomDeliveryMessage(variant.deliveryMessage);
        } else {
          this.showDefaultShippingMessage();
        }
      }

      /**
       * Sets delivery messaging based on current time and country.
       *
       * Checks for delivery message element existence, determines if the message
       * is already overridden, and applies country-specific delivery messaging
       * based on current time and configured cutoff hour.
       *
       * @returns {void}
       */
      shipsIn() {
        const deliveryMessageEl = this.summaryElements.deliveryMessage;
        if (!deliveryMessageEl) {
          this.logger?.warn('No delivery message element found');
          return;
        }

        if (this.isDeliveryMessageOverridden(deliveryMessageEl)) {
          return;
        }

        const countryCode = window.theme.country_code;
        const { day, hours } = this.getCurrentTimeInfo();
        const hourCutoff = parseInt(window.theme.pdp_delivery_time_cutoff, 10);

        if (countryCode === 'GB' || countryCode === 'IE') {
          this.setGBDeliveryMessage(day, hours, hourCutoff);
        } else {
          this.setGlobalDeliveryMessage(day, hours, hourCutoff);
        }
      }

      /**
       * Updates Back-in-Stock modal input values with current product and variant IDs.
       *
       * Sets the product ID and variant ID in the BIS modal inputs and updates
       * the notify button's variant ID attribute when these elements exist.
       *
       * @returns {void}
       */
      updateBisModalInputs() {
        this.logger?.log('updateBisButtonVariantId');

        const bisVariantIdInput = this.summaryElements.bisModalVariantId;

        if (bisVariantIdInput) {
          bisVariantIdInput.value = this.state.variant.id;
          this.summaryElements.notifyButton?.setAttribute(
            CONSTANTS.DATA_ATTR.NOTIFY_BTN_VARIANT_ID,
            this.state.variant.id
          );
        }
      }

      /**
       * Checks if a variant SKU represents a gift card.
       *
       * @param {string} variantSku - The SKU to check
       * @returns {boolean} True if the SKU exists and starts with 'GC', false otherwise
       */
      isGiftCard(variantSku) {
        return variantSku && variantSku.startsWith('GC');
      }

      /**
       * Displays the gift card delivery message and hides the notify button.
       *
       * Shows the delivery accent element and hides the notify button
       * when a gift card product is selected.
       *
       * @returns {void}
       */
      showGiftCardDeliveryMessage() {
        this.logger?.log('showGiftCardDeliveryMessage');
        this.summaryElements.notifyButton.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
        this.summaryElements.deliveryAccent.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
      }

      /**
       * Displays the out-of-stock message by clearing delivery content.
       *
       * Clears the delivery message text content and hides the
       * delivery accent element when a product is out of stock.
       *
       * @returns {void}
       */
      showOutOfStockMessage() {
        this.logger?.log('showOutOfStockMessage');
        this.summaryElements.deliveryMessage.textContent = '';
        this.summaryElements.deliveryAccent?.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
      }

      /**
       * Sets a custom delivery message in the UI.
       *
       * Decodes and displays the provided message in the delivery message element,
       * updates the delivery message props input value if it exists, and shows
       * the delivery accent element.
       *
       * @param {string} message - The URI-encoded delivery message to display
       * @returns {void}
       */
      showCustomDeliveryMessage(message) {
        this.logger?.log('showCustomDeliveryMessage');

        const decodedMessage = decodeURI(message);
        this.summaryElements.deliveryMessage.textContent = decodedMessage;

        const deliveryMessagePropsInput = this.summaryElements.deliveryMessagePropsInput;
        if (deliveryMessagePropsInput) deliveryMessagePropsInput.value = decodedMessage;

        this.summaryElements.deliveryAccent?.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
      }

      /**
       * Displays the default shipping message based on current time and location.
       *
       * Calls the shipsIn method to set appropriate delivery messaging,
       * clears the delivery message props input if it exists, and
       * shows the delivery accent element.
       *
       * @returns {void}
       */
      showDefaultShippingMessage() {
        this.logger?.log('showDefaultShippingMessage');

        this.shipsIn();

        const deliveryMessagePropsInput = this.summaryElements.deliveryMessagePropsInput;
        if (deliveryMessagePropsInput) deliveryMessagePropsInput.value = '';

        this.summaryElements.deliveryAccent?.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
      }

      /**
       * Checks if the delivery message has been overridden.
       *
       * Determines if the delivery message should use custom content based on:
       * 1. The element having an override class (which is then removed)
       * 2. A global theme shipping message override being present
       *
       * @param {HTMLElement} deliveryMessageEl - The delivery message element to check
       * @returns {boolean} True if the message has been overridden, false otherwise
       */
      isDeliveryMessageOverridden(deliveryMessageEl) {
        this.logger?.log('isDeliveryMessageOverridden');
        if (deliveryMessageEl.classList.contains(CONSTANTS.CSS_CLASSES.OVERRIDE)) {
          deliveryMessageEl.classList.remove(CONSTANTS.CSS_CLASSES.OVERRIDE);
          return true;
        }

        if (window.theme.shipping_message_override) {
          deliveryMessageEl.innerHTML = window.theme.pdp_delivery_message;
          return true;
        }

        return false;
      }

      /**
       * Gets the current day of week and hour.
       *
       * @returns {Object} Object containing day (0-6, where 0 is Sunday) and hours (0-23)
       */
      getCurrentTimeInfo() {
        const currentDate = new Date();
        return {
          day: currentDate.getDay(), // 0 = Sunday, 6 = Saturday
          hours: currentDate.getHours(),
        };
      }

      /**
       * Sets UK-specific delivery messaging based on current day and time.
       *
       * Displays different delivery messages for weekdays vs weekend and
       * based on whether the current time is before or after the cutoff hour.
       *
       * @param {number} day - Current day of week (0-6)
       * @param {number} hours - Current hour (0-23)
       * @param {number} hourCutoff - Cutoff hour for same-day processing
       * @returns {void}
       */
      setGBDeliveryMessage(day, hours, hourCutoff) {
        if (day >= 1 && day <= 4) {
          // Monday to Thursday
          if (hours < hourCutoff) {
            this.summaryElements.deliveryMessage.innerHTML = window.theme.pdp_delivery_message_today;
          } else {
            this.summaryElements.deliveryMessage.innerHTML = window.theme.pdp_delivery_message_tomorrow;
          }
        } else if (day === 5) {
          // Friday
          if (hours < hourCutoff) {
            this.summaryElements.deliveryMessage.innerHTML = window.theme.pdp_delivery_message_monday;
          } else {
            this.summaryElements.deliveryMessage.innerHTML = window.theme.pdp_delivery_message_tuesday;
          }
        } else {
          // Weekend
          this.summaryElements.deliveryMessage.innerHTML = window.theme.pdp_delivery_message_tuesday;
        }
      }

      /**
       * Sets global delivery messaging based on current day and time.
       *
       * Displays different delivery messages based on day of week and
       * whether the current time is before or after the cutoff hour.
       * Prepends the theme's "ships" text to all messages.
       *
       * @param {number} day - Current day of week (0-6)
       * @param {number} hours - Current hour (0-23)
       * @param {number} hourCutoff - Cutoff hour for same-day processing
       * @returns {void}
       */
      setGlobalDeliveryMessage(day, hours, hourCutoff) {
        const shipsText = window.theme.pdp_delivery_message_ships + ' ';

        if (day === 0) {
          // Sunday
          this.summaryElements.deliveryMessage.innerHTML = shipsText + window.theme.pdp_delivery_message_tomorrow;
        } else if ((day === 5 && hours >= hourCutoff) || day === 6) {
          // Friday after cutoff or Saturday
          this.summaryElements.deliveryMessage.innerHTML = shipsText + window.theme.pdp_delivery_message_monday;
        } else if (hours >= hourCutoff) {
          // After cutoff time
          this.summaryElements.deliveryMessage.innerHTML = shipsText + window.theme.pdp_delivery_message_tomorrow;
        } else {
          // Before cutoff time
          this.summaryElements.deliveryMessage.innerHTML = shipsText + window.theme.pdp_delivery_message_today;
        }
      }

      /**
       * Swipers Management
       * @namespace Swipers
       */

      /**
       * Creates swiper instances for all swiper containers on the page.
       *
       * Finds all swiper containers, extracts their product IDs, and
       * creates and stores swiper instances in the swipers Map object.
       *
       * @returns {void}
       */
      createSwipers() {
        const swiperContainers = document.querySelectorAll(CONSTANTS.SELECTORS.SWIPER_CONTAINER);

        swiperContainers.forEach((container) => {
          const productId = container.getAttribute(CONSTANTS.DATA_ATTR.SWIPER_PRODUCT_ID);

          this.swipers.set(productId, this.createSwiperInstance(container, productId));
        });

        this.logger?.log('Swipers created', this.swipers);
      }

      /**
       * Creates a new Swiper instance for a specific container.
       *
       * Configures the Swiper with navigation, pagination, loop settings,
       * breakpoints, and event handlers. Only initializes the swiper
       * if it matches the current active product.
       *
       * @param {HTMLElement} container - The container element for the Swiper
       * @param {string} productId - Product ID associated with this Swiper
       * @returns {Swiper} Configured Swiper instance
       */
      createSwiperInstance(container, productId) {
        const isActive = productId === this.state.product.id;

        return new window.Swiper(container, {
          init: isActive,
          slidesPerView: 1,
          allowTouchMove: true,
          loop: true,
          pagination: {
            el: `${CONSTANTS.SELECTORS.SWIPER_CONTAINER}[${CONSTANTS.DATA_ATTR.SWIPER_PRODUCT_ID}="${productId}"] ${CONSTANTS.SELECTORS.SWIPER_PAGINATION}`,
          },
          navigation: {
            nextEl: `${CONSTANTS.SELECTORS.SWIPER_CONTAINER}[${CONSTANTS.DATA_ATTR.SWIPER_PRODUCT_ID}="${productId}"] ${CONSTANTS.SELECTORS.SWIPER_BUTTON_NEXT}`,
            prevEl: `${CONSTANTS.SELECTORS.SWIPER_CONTAINER}[${CONSTANTS.DATA_ATTR.SWIPER_PRODUCT_ID}="${productId}"] ${CONSTANTS.SELECTORS.SWIPER_BUTTON_PREV}`,
          },
          breakpoints: {
            820: {
              loop: false,
            },
          },
          on: this.getSwiperEventHandlers(),
        });
      }

      /**
       * Returns event handlers for a Swiper carousel.
       *
       * @returns {Object} Event handlers for Swiper
       * @returns {Function} returns.afterInit - Makes pagination and navigation elements visible after initialization
       * @returns {Function} returns.breakpoint - Updates navigation on breakpoint change
       * @returns {Function} returns.touchMove - Prevents sliding when user is zoomed in (scale > 1.2)
       * @returns {Function} returns.touchEnd - Re-enables sliding when zoom level is back to normal (scale <= 1.2)
       */
      getSwiperEventHandlers() {
        return {
          afterInit: (swiper) => {
            swiper.pagination.el.style.visibility = 'visible';
            swiper.navigation.prevEl.style.visibility = 'visible';
            swiper.navigation.nextEl.style.visibility = 'visible';
          },
          breakpoint: function () {
            this.navigation.update();
          },
          touchMove: function (swiper, event) {
            if (event.touches && window.visualViewport.scale > 1.2) {
              this.allowSlideNext = false;
              this.allowSlidePrev = false;
            }
          },
          touchEnd: function (swiper, event) {
            if (event.touches && window.visualViewport.scale <= 1.2) {
              this.allowSlideNext = true;
              this.allowSlidePrev = true;
            }
          },
        };
      }

      /**
       * Updates visibility of Swiper containers based on the current product ID
       * and updates variant slides for the current product.
       *
       * @returns {void}
       */
      updateActiveSwiper() {
        const productId = this.state.product.id;
        const swiperContainers = document.querySelectorAll(CONSTANTS.SELECTORS.SWIPER_CONTAINER);

        swiperContainers.forEach((container) => {
          const isCurrentProduct = container.getAttribute(CONSTANTS.DATA_ATTR.SWIPER_PRODUCT_ID) === productId;

          if (isCurrentProduct) {
            container.classList.remove(CONSTANTS.CSS_CLASSES.HIDDEN);
          } else {
            container.classList.add(CONSTANTS.CSS_CLASSES.HIDDEN);
          }
        });

        // Update slides based on variant
        this.updateVariantSlides(productId);
      }

      /**
       * Updates the visible slides for a specific product variant.
       *
       * @param {string|number} [productId=this.state.product.id] - The product ID to update slides for
       * @returns {void}
       *
       * @throws {Error} Implicitly may throw if swiper methods fail
       */
      updateVariantSlides(productId = this.state.product.id) {
        const swiper = this.swipers.get(productId);
        const variantId = this.state.variant.id;

        if (!swiper) {
          this.logger?.log(`Swiper for product id ${productId} not found`);
          return;
        }

        const allSlides = this.getSlidesForProduct(productId);
        const visibleSlides = allSlides.filter(
          (slide) => slide.getAttribute(CONSTANTS.DATA_ATTR.SWIPER_VARIANT_ID) === variantId
        );

        // If no visible slides or slides already in correct state, skip update
        if (!visibleSlides.length || this.areSlidesCorrectlyConfigured(visibleSlides, allSlides)) {
          if (!swiper.initialized) {
            swiper.init();
          }

          this.logger?.log(`Swiper for product id ${productId} already in correct state`);
          return;
        }

        // Update slide visibility
        this.configureSlideVisibility(allSlides, visibleSlides);

        // Update swiper configuration and reset to first slide
        this.updateSwiperConfiguration(swiper, visibleSlides);
      }

      /**
       * Retrieves all slide elements for a specific product.
       *
       * @param {string|number} productId - The product ID to get slides for
       * @returns {Array<Element>} Array of slide DOM elements for the specified product
       */
      getSlidesForProduct(productId) {
        return Array.from(
          document.querySelectorAll(
            `${CONSTANTS.SELECTORS.SWIPER_CONTAINER}[${CONSTANTS.DATA_ATTR.SWIPER_PRODUCT_ID}="${productId}"] ${CONSTANTS.SELECTORS.VARIANT_IMAGES}`
          )
        );
      }

      /**
       * Checks if slides are correctly configured based on visibility requirements.
       *
       * @param {Array<Element>} visibleSlides - Slides that should be visible
       * @param {Array<Element>} allSlides - All slides for the product
       * @returns {boolean} True if all slides have correct visibility classes
       */
      areSlidesCorrectlyConfigured(visibleSlides, allSlides) {
        const allSlidesCorrect = visibleSlides.every(
          (slide) =>
            slide.classList.contains(CONSTANTS.CSS_CLASSES.SWIPER_SLIDE) &&
            !slide.classList.contains(CONSTANTS.CSS_CLASSES.SWIPER_HIDDEN_SLIDE)
        );

        const hiddenSlides = allSlides.filter((slide) => !visibleSlides.includes(slide));
        const allHiddenCorrect = hiddenSlides.every(
          (slide) =>
            !slide.classList.contains(CONSTANTS.CSS_CLASSES.SWIPER_SLIDE) &&
            slide.classList.contains(CONSTANTS.CSS_CLASSES.SWIPER_HIDDEN_SLIDE)
        );

        return allSlidesCorrect && allHiddenCorrect;
      }

      /**
       * Updates visibility classes for all slides based on which slides should be visible.
       *
       * @param {Array<Element>} allSlides - All slides for the product
       * @param {Array<Element>} visibleSlides - Slides that should be visible
       * @returns {void}
       */
      configureSlideVisibility(allSlides, visibleSlides) {
        allSlides.forEach((slide) => {
          const isVisible = visibleSlides.includes(slide);
          slide.classList.toggle(CONSTANTS.CSS_CLASSES.SWIPER_SLIDE, isVisible);
          slide.classList.toggle(CONSTANTS.CSS_CLASSES.SWIPER_HIDDEN_SLIDE, !isVisible);
        });
      }

      /**
       * Updates Swiper configuration based on current visible slides.
       *
       * @param {Object} swiper - The Swiper instance to update
       * @param {Array<Element>} visibleSlides - Slides that should be visible
       * @returns {void}
       *
       * @throws {Error} Implicitly may throw if Swiper methods fail
       */
      updateSwiperConfiguration(swiper, visibleSlides) {
        if (!swiper.initialized) {
          swiper.init();
          return;
        }

        // Handle loop update if needed
        if (swiper.params.loop) {
          swiper.loopDestroy();

          if (visibleSlides.length > 1) {
            // Reorder slides in wrapper
            const swiperWrapper = swiper.wrapperEl;
            if (swiperWrapper) {
              visibleSlides.forEach((slide) => swiperWrapper.appendChild(slide));
            }

            // Update loop configuration
            swiper.params.loopedSlides = visibleSlides.length;
            swiper.loopCreate();
            swiper.slideToLoop(0, 0);
          }
        } else {
          swiper.slideTo(0, 0);
        }

        // Update swiper state
        swiper.update();
        swiper.pagination.update();
        swiper.navigation.update();
      }

      /**
       * Sets up a sticky mobile swiper gallery that follows scroll position
       * using GSAP ScrollTrigger.
       *
       * Creates responsive behavior that moves the product carousel between
       * its original position and next to the variant picker section based on
       * scroll position and viewport size.
       *
       * @returns {void}
       */
      handleStickyMobileSwiper() {
        this.logger?.log('handleStickyMobileSwiper');

        const swiperGallery = document.querySelector(CONSTANTS.SELECTORS.PRODUCT_CAROUSEL);
        const pickersSection =
          this.querySelector(CONSTANTS.SELECTORS.SIBLING_PRODUCTS) &&
          this.querySelector(CONSTANTS.SELECTORS.SIBLING_VARIANTS);
        const mobileProductTitle = this.querySelector(CONSTANTS.SELECTORS.MOBILE_PRODUCT_TITLE);
        const gsapScrollTrigger = window.ScrollTrigger;

        if (!swiperGallery || !pickersSection || !gsapScrollTrigger || !mobileProductTitle) {
          this.logger?.warn('Required elements for sticky mobile swiper not found');
          return;
        }

        let scrollerStart = 0;
        let scrollerEnd = 0;
        let scrollTriggerInstance = null;
        let isMobileView = window.matchMedia('(min-width: 820px)').matches === false;
        let windowWidth = window.innerWidth;

        const getScrollerLimits = () => {
          const header = document.querySelector(CONSTANTS.SELECTORS.SECTION_HEADER);
          scrollerStart = header?.offsetHeight || 0;
          scrollerEnd = swiperGallery.offsetHeight + scrollerStart;
          this.logger?.log('Updated scroller limits', { scrollerStart, scrollerEnd });
        };

        const moveSwiperToPickers = () => {
          document.documentElement.style.setProperty(
            CONSTANTS.CSS_VARS.MOVED_SWIPER_TOP,
            `${pickersSection.offsetTop - swiperGallery.offsetHeight}px`
          );
          pickersSection.before(swiperGallery);
          swiperGallery.classList.add(CONSTANTS.CSS_CLASSES.MOVED);
        };

        const moveSwiperToInitialPosition = () => {
          swiperGallery.classList.remove(CONSTANTS.CSS_CLASSES.MOVED);
          mobileProductTitle.after(swiperGallery);
        };

        const createScrollTrigger = () => {
          if (!isMobileView) return;

          getScrollerLimits();

          scrollTriggerInstance = gsapScrollTrigger.create({
            markers: false,
            trigger: swiperGallery,
            start: `top ${scrollerStart}px`,
            endTrigger: pickersSection,
            end: `top ${scrollerEnd}px`,
            toggleClass: CONSTANTS.CSS_CLASSES.STICKY,
            onLeave: () => moveSwiperToPickers(),
            onEnterBack: () => moveSwiperToInitialPosition(),
          });

          this.logger?.log('ScrollTrigger created');
        };

        const destroyScrollTrigger = () => {
          if (scrollTriggerInstance) {
            scrollTriggerInstance.kill();
            scrollTriggerInstance = null;
            this.logger?.log('ScrollTrigger destroyed');
          }
        };

        const handleResize = () => {
          this.logger?.log('handleResize');
          const actualMobileView = window.matchMedia('(min-width: 820px)').matches === false;

          if (actualMobileView !== isMobileView) {
            isMobileView = actualMobileView;
            if (isMobileView) {
              window.scrollTo(0, 0);
              createScrollTrigger();
              this.logger?.log('Switching to mobile view');
            } else {
              destroyScrollTrigger();
              swiperGallery.classList.remove(CONSTANTS.CSS_CLASSES.STICKY);
              moveSwiperToInitialPosition();
              this.logger?.log('Switching to desktop view');
            }
          }
        };

        if (isMobileView) createScrollTrigger();

        window.addEventListener(CONSTANTS.EVENTS.WINDOW_RESIZE, () => {
          if (window.innerWidth !== windowWidth) {
            windowWidth = window.innerWidth;
            handleResize();
          }
        });
      }

      /**
       * Common methods and helpers
       * @namespace Common
       */

      /**
       * Run callback when DOM is ready
       * @param {Function} callback - Function to execute when DOM is ready
       */
      onDomReady(callback) {
        if (document.readyState === 'loading') {
          document.addEventListener(CONSTANTS.EVENTS.DOM_CONTENT_LOADED, callback);
        } else {
          callback();
        }
      }

      /**
       * Retrieves and parses JSON data from script tags that match the given selectors and IDs.
       *
       * @param {string|number} [id=this.state.product.id] - Primary ID to search for
       * @param {string} [selector=CONSTANTS.DATA_ATTR.JSON_SIBLING_PRODUCT_ID] - Primary selector attribute
       * @param {string|number|null} [secondId=null] - Optional secondary ID to search for
       * @param {string|null} [secondSelector=null] - Optional secondary selector attribute
       * @returns {Object|null} Parsed JSON data or null if not found or parsing fails
       */
      getJsonData(
        id = this.state.product.id,
        selector = CONSTANTS.DATA_ATTR.JSON_SIBLING_PRODUCT_ID,
        secondId = null,
        secondSelector = null
      ) {
        let queryString = `script[${selector}="${id}"]`;

        if (secondId !== null && secondSelector) {
          queryString = `script[${selector}="${id}"][${secondSelector}="${secondId}"]`;
        }

        this.logger?.log('getJsonData', queryString);

        const jsonDataEl = document.querySelector(queryString);

        if (!jsonDataEl) {
          this.logger?.warn(`No json data found for ${selector} with ID:`, id);
          return null;
        }

        try {
          const dataJson = JSON.parse(jsonDataEl.innerHTML);
          this.logger?.log('Parsed json data:', dataJson);
          return dataJson;
        } catch (error) {
          this.logger?.error('Error parsing json data:', error);
          return null;
        }
      }

      /**
       * Checks if a button element has an active state.
       *
       * @param {Element} button - Button element to check
       * @returns {boolean} True if the button is active, false otherwise
       */
      isButtonActive(button) {
        return (
          button.hasAttribute(CONSTANTS.DATA_ATTR.BUTTON_STATE) &&
          button.getAttribute(CONSTANTS.DATA_ATTR.BUTTON_STATE) === CONSTANTS.STATES.ACTIVE
        );
      }

      /**
       * Checks if a section element has an active state.
       *
       * @param {Element|null} section - Section element to check
       * @returns {boolean} True if the section is active, false otherwise
       */
      isSectionActive(section) {
        if (!section || !section.hasAttribute(CONSTANTS.DATA_ATTR.SECTION_STATE)) {
          this.logger?.warn('Section is not defined or does not have a data-section-state attribute');
          return false;
        }

        return section.getAttribute(CONSTANTS.DATA_ATTR.SECTION_STATE) === CONSTANTS.STATES.ACTIVE;
      }

      /**
       * Sets the state attribute on a button element.
       *
       * @param {Element} button - Button element to modify
       * @param {string} state - State value to set
       * @returns {void}
       */
      setButtonState(button, state) {
        button.setAttribute(CONSTANTS.DATA_ATTR.BUTTON_STATE, state);
      }

      /**
       * Sets the state attribute on a section element.
       *
       * @param {Element} section - Section element to modify
       * @param {string} state - State value to set
       * @returns {void}
       */
      setSectionState(section, state) {
        section.setAttribute(CONSTANTS.DATA_ATTR.SECTION_STATE, state);
      }

      /**
       * Updates the state of all buttons in a section or collection of buttons.
       *
       * @param {Element|NodeList|Array} sectionOrButtons - Either a section element containing buttons or a collection of button elements
       * @param {Element|null} [activeButton=null] - The button to set as active (all others will be set to initial state)
       * @returns {void}
       */
      updateSectionButtonsState(sectionOrButtons, activeButton = null) {
        let buttons;

        // Check if sectionOrButtons is a DOM element with querySelectorAll method
        if (sectionOrButtons && typeof sectionOrButtons.querySelectorAll === 'function') {
          buttons = sectionOrButtons.querySelectorAll(CONSTANTS.SELECTORS.BUTTON);
        } else {
          // Otherwise use it directly as the buttons collection
          buttons = sectionOrButtons;
        }

        if (!buttons || buttons.length === 0) {
          this.logger?.warn('No buttons found');
          return;
        }

        buttons.forEach((button) => {
          this.setButtonState(button, button === activeButton ? CONSTANTS.STATES.ACTIVE : CONSTANTS.STATES.INITIAL);
        });
      }

      /**
       * Creates a hidden input element for a form.
       *
       * @param {string} name - The name attribute for the input element
       * @param {string|number} value - The value attribute for the input element
       * @param {string} className - CSS class to be added to the input element
       * @returns {HTMLInputElement} - The created hidden input element
       */
      createFormHiddenInput(name, value, className) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.classList.add(className);

        return input;
      }

      /**
       * Loads all lazy images using window.lazyLoadInstance with browser-appropriate timing.
       * Uses requestIdleCallback when available, with setTimeout as fallback for unsupported browsers.
       *
       * @returns {void}
       */
      loadLazyImagesWithFallback() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            if (window.lazyLoadInstance && typeof window.lazyLoadInstance.loadAll === 'function') {
              window.lazyLoadInstance.loadAll();
              this.logger?.log('All lazy-loaded images have been loaded (requestIdleCallback)');
            }
          });
        } else {
          // Fallback for browsers without requestIdleCallback
          setTimeout(() => {
            if (window.lazyLoadInstance && typeof window.lazyLoadInstance.loadAll === 'function') {
              window.lazyLoadInstance.loadAll();
              this.logger?.log('All lazy-loaded images have been loaded (setTimeout fallback)');
            }
          }, 200); // Small delay to avoid blocking critical tasks
        }
      }
    }
  );
}
